import layout from "./layout";
import global from "./global";

const rootReducer = {
  layout,
  global,
};
export default rootReducer;
